import { render, staticRenderFns } from "./PhotoText.vue?vue&type=template&id=a6c302ec&"
import script from "./PhotoText.vue?vue&type=script&lang=js&"
export * from "./PhotoText.vue?vue&type=script&lang=js&"
import style0 from "./PhotoText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports